<template>
  <div class="studio-page clipr-theme twitch-theme">
    <converter-collection-panel
      :translate="tt"
      :has-active-plan="canUseStudioPro"
      :is-admin-user="isStudioAdmin"
      @pro-action-blocked="openStudioSubscriptionPromptModal"
    />

    <schedule-subscription-prompt-modal
      v-model="showStudioSubscriptionPromptModal"
      :has-active-plan="canUseStudioPro"
      @close="closeStudioSubscriptionPromptModal"
      @subscribe="openSubscriptionFromStudioPrompt"
    />
  </div>
</template>

<script>
import { mapState } from "pinia";
import ScheduleSubscriptionPromptModal from "@/components/common/ScheduleSubscriptionPromptModal.vue";
import ConverterCollectionPanel from "@/components/clipr/converter/ConverterCollectionPanel.vue";
import { useCurrentUserStore } from "@/stores/currentUser";
import { isImpersonating } from "@/utils/impersonation";

export default {
  name: "Studio",
  components: {
    ScheduleSubscriptionPromptModal,
    ConverterCollectionPanel,
  },
  data() {
    return {
      showStudioSubscriptionPromptModal: false,
    };
  },
  computed: {
    ...mapState(useCurrentUserStore, ["canEditClips", "useRole"]),
    isStudioAdmin() {
      return String(this.useRole || "").trim().toLowerCase() === "admin";
    },
    canUseStudioPro() {
      return isImpersonating() || this.isStudioAdmin || this.canEditClips === true;
    },
  },
  async mounted() {
    try {
      const currentUserStore = useCurrentUserStore();
      await currentUserStore.syncSubscriptionStatus();
    } catch (error) {
      console.warn("No se pudo refrescar el estado de suscripción en Studio:", error);
    }
  },
  methods: {
    tt(key, fallback) {
      return typeof this.$t === "function" ? this.$t(key) : fallback;
    },
    openStudioSubscriptionPromptModal() {
      if (this.canUseStudioPro) return;
      this.showStudioSubscriptionPromptModal = true;
    },
    closeStudioSubscriptionPromptModal() {
      this.showStudioSubscriptionPromptModal = false;
    },
    async openSubscriptionFromStudioPrompt() {
      this.closeStudioSubscriptionPromptModal();
      if (!this.$router) return;
      try {
        await this.$router.push({ name: "billing" });
      } catch (error) {
        const message = String(error?.message || "");
        if (!message.includes("NavigationDuplicated")) {
          console.warn("No se pudo abrir Billing desde Studio:", error);
        }
      }
    },
  },
};
</script>

<style scoped>
.studio-page {
  padding: 0 4px 20px;
}
</style>
